const Vue = require("vue");

new Vue({
	el: "#app",

	data: {
		email: "",
		agreement: "",
	},

	mounted() {
		if (window._forgot.email) {
			this.email = window._forgot.email;
		}

		if (window._forgot.agreement) {
			this.agreement = window._forgot.agreement;
		}
	},
});
